<template>
  <v-container class="pa-0" fluid>
    <v-container id="header" class="pa-0" fluid>
      <v-container class="pa-0 content-wrapper top-header">
        <div class="logo float-left">
          <img src="~@/assets/images/web_logo.svg" alt="logo" />
        </div>
        <div class="header-info float-right">
          <p class="site-title">東港鎮水資源回收中心</p>
          <p class="system-name">營管資訊系統</p>
          <span class="user-info" v-if="loginTokenGetter">
            <p>{{ usernameGetter }}</p>
            <p class="logout-action" @click="logout">登出</p>
          </span>
          <span v-else>
            <router-link to="/login">登入</router-link>
          </span>
        </div>
      </v-container>
    </v-container>
    <v-container id="header-menu" class="pa-0" fluid>
      <v-container class="pa-0 content-wrapper">
        <ul class="main-menu">
          <li>
            <router-link to="/basic">基本資料展示</router-link>
          </li>
          <li>
            <router-link to="/inspection">巡檢填報</router-link>
          </li>
          <li>
            <a :href="`${domain}/projects/donggang/issues?query_id=8`" target="_BLANK">備品耗材</a>
          </li>
          <li>
            <a :href="`${domain}/projects/donggang/wiki`" target="_BLANK">廠區行政</a>
          </li>
          <li>
            <a :href="`${domain}/projects/donggang/settings/members`" target="_BLANK">系統後台</a>
          </li>
        </ul>
      </v-container>
    </v-container>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import getEnv from '@/utils/env'
export default {
  components: {},
  name: 'HeaderPart',
  data () {
    return {
      domain: getEnv('VUE_APP_BASE_URL')
    }
  },
  watch: {
  },
  created () {
    console.log('domain', this.domain)
  },
  computed: {
    ...mapGetters('auth', ['loginTokenGetter', 'usernameGetter'])
  },
  methods: {
    ...mapActions('auth', ['logout'])
  }
}
</script>
<style lang="scss" scoped>
#header{
  background-color: #fff;
  .top-header{
    height:90px;
    .logo{
      margin-top:26px;
    }
    .header-info{
      margin-top:30px;
      p, a{
        display: inline-block;
        padding: 0 10px;
        border-right:1px solid #505050;
        &:last-child{
          border-right:none;
        }
      }
    }
  }
}
#header-menu{
  background-color:#3F82BA;
  height:90px;
  ul{
    list-style: none;
    display: flex;
    justify-content: space-between;
    li{
      margin-top:26px;
      a{
        color:rgba(255,255,255,0.7);
        text-decoration: none;
        font-size: 18px;
        line-height: 30px;
        &.router-link-active{
          color: #fff;
          border-bottom: 2px solid #fff;
        }

        &.router-link-exact-active{
          color: #fff;
          border-bottom: 2px solid #fff;
        }
      }
    }
  }
}
.logout-action{
  cursor: pointer;
}
// media width max 767px
@media (max-width: 767px) {
  #header{
    .top-header{
      height:60px;
      .logo{
        margin-top:10px;
      }
      .header-info{
        margin-top:10px;
        p, a{
          padding: 0 5px;
        }
        .site-title{
          display: none;
        }
        .system-name{
          display: none;
        }
      }
    }
  }
  #header-menu{
    height:60px;
    .main-menu{
      width: 100%;
      padding: 0;
    }
    ul{
      li{
        margin-top:10px;
        a{
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
